<template>
  <div v-if="loaded">
    <CRow class="ml-0 mr-0 photo" :style="background">
      <CCol class="d-flex col-12 justify-content-between card-carousel">
        <CCol class="content col-11 col-sm-5 pl-0 pr-0">
          <CModal
            add-content-classes="bg-transparent border-0"
            :show.sync="modalEnroll"
            centered
            :closeOnBackdrop="false"
          >
            <template #header-wrapper>
              <div @click="modalEnroll = false" class="closeBtnContainer">
                <p class="closeButton">
                  <img
                    class="closeButtonItem"
                    src="@/assets/icons/closeButton.svg"
                  />
                </p>
              </div>
            </template>
            <template #body-wrapper>
              <div class="modalEnroll">
                <h2>NOTICE !</h2>
                <p style="text-align: justify; text-indent: 30px">
                  <b
                    ><span style="color: red">
                      You cannot enroll
                      <strong v-if="dataCourse !== null">{{
                        dataCourse.data.data.controls.name[0].val
                      }}</strong>
                      because this subject is not found in your schedule on the
                      REG system</span
                    ></b
                  >
                </p>
                <p>
                  Please check your class schedule. If this subject is not in
                  your schedule, Contact <b>REG:</b>
                  <span
                    style="cursor: pointer; color: blue"
                    @click="clickREGLINK()"
                    >https://reg.mfu.ac.th/th/contact-us</span
                  >
                </p>
                <br />
                <!-- Can not register for
                  <strong v-if="dataCourse !== null">{{
                    dataCourse.data.data.controls.name[0].val
                  }}</strong>
                  in MDL system. Please contact the division of registrar to
                  complete the enrolment process or call 053-9999999 after contact with 
                  division of registrar please login again -->

                <CButton
                  @click="modalEnroll = false"
                  class="btnModal-enroll mb-3"
                  >SUBMIT</CButton
                >
              </div>
            </template>
            <template #footer-wrapper>
              <span></span>
            </template>
          </CModal>
          <h1 v-if="this.dataCourse.data.data.controls.name">
            {{
              $helpers.translate(this.dataCourse.data.data.controls.name, lang)
            }}
          </h1>
          <h5 v-if="this.courseSection" style="color: white">
            Section : {{ this.courseSection }}
          </h5>
          <p
            v-if="this.dataCourse.data.data.controls.subtitle"
            class="p-content text-justify"
            style="text-indent: 60px"
          >
            {{
              $helpers.translate(
                this.dataCourse.data.data.controls.subtitle,
                lang
              )
            }}
          </p>
          <br />
          <div v-if="getStartButton != ''">
            <CButton v-if="loading" class="btn-overview hover"
              ><i class="fas fa-circle-notch fa-spin"></i
            ></CButton>

            <div v-else>
              <CButton
                v-if="this.$store.getters[`auth/userStatus`]"
                block
                @click="Getstart"
                class="btn-overview hover"
              >
                {{ getStartButton }}</CButton
              >
            </div>
          </div>
          <div v-else>
            <CButton
              v-if="this.$store.getters[`auth/userStatus`]"
              block
              class="btn-disable hover"
              ><i class="fas fa-circle-notch fa-spin"></i
            ></CButton>
          </div>
        </CCol>
        <CCol class="col-12 col-sm-6 embed-responsive">
          <video
            autoplay
            controls
            loop
            v-if="dataCourse.data.data.controls.carousels.url"
            class="embed-responsive-item"
            style="width: 80%"
            frameborder="0"
            :src="dataCourse.data.data.controls.carousels.url"
            allow="accelerometer; autoplay; encrypted-media;  picture-in-picture"
          ></video>
        </CCol>
      </CCol>
    </CRow>
    <CRow
      class="m-0 p-0 d-flex justify-content-between col-sm-12 col-12 bg-white"
    >
      <!-- Detail left -->
      <CCol class="CSDetailleft mb-5 col-sm-5 col-12">
        <h1>Course Overview</h1>
        <CCol class="CourseInfo">
          <CRow>
            <CCol class="col-sm-6">
              <h1>Course Name :</h1>
            </CCol>
            <CCol class="col-sm-6 pl-0">
              <p v-if="this.dataCourse.data.data.controls.name">
                {{
                  $helpers.translate(
                    this.dataCourse.data.data.controls.name,
                    lang
                  )
                }}
              </p>
              <p v-else>-</p>
            </CCol>
          </CRow>
        </CCol>
        <CCol class="CourseType">
          <CRow>
            <CCol class="col-sm-6">
              <h1>Course Type :</h1>
            </CCol>
            <CCol class="col-sm-6 pl-0">
              <p v-if="dataCourse.data.data.controls.types[0].type.type">
                <img class="check" src="@/assets/images/wait/Check.svg" />
                {{
                  $helpers.translate(
                    dataCourse.data.data.controls.types[0].type.type,
                    lang
                  )
                }}
              </p>
              <p v-else>-</p>
            </CCol>
          </CRow>
        </CCol>
        <CCol class="StudyTime">
          <CRow>
            <CCol class="col-sm-6">
              <h1>Study Hour :</h1>
            </CCol>
            <CCol class="col-sm-6 pl-0">
              <p v-if="dataCourse.data.data.controls.studyHour">
                <img class="check" src="@/assets/images/wait/Check.svg" />
                {{ dataCourse.data.data.controls.studyHour }}
              </p>
              <p v-else>-</p>
            </CCol>
          </CRow>
        </CCol>
        <CCol class="Catagory">
          <CRow>
            <CCol class="col-sm-6">
              <h1>Category :</h1>
            </CCol>
            <CCol class="col-sm-6 pl-0">
              <p
                v-if="dataCourse.data.data.controls.categorys[0].category.title"
              >
                <img class="check" src="@/assets/images/wait/Check.svg" />
                {{
                  $helpers.translate(
                    dataCourse.data.data.controls.categorys[0].category.title,
                    lang
                  )
                }}
              </p>
              <p v-else>-</p>
            </CCol>
          </CRow>
        </CCol>
        <CCol class="Instructor" v-if="this.$store.getters['auth/userStatus']">
          <CRow>
            <CCol class="col-sm-6">
              <h1>Instructor :</h1>
            </CCol>
            <CCol
              class="col-sm-6"
              v-if="dataCourse.data.instructors.length > 0"
            >
              <CRow
                v-for="(item, index) in dataCourse.data.instructors"
                :key="index"
              >
                <div
                  v-if="item.firstname.length != 0 && item.lastname.length != 0"
                >
                  <p>
                    {{ index + 1 }}.
                    {{ $helpers.translate(item.firstname, lang) }}
                  </p>
                  <p class="pl-3">
                    {{ $helpers.translate(item.lastname, lang) }}
                  </p>
                </div>
              </CRow>
            </CCol>
            <CCol class="col-sm-6" v-else>
              <CRow>
                <p>-</p>
              </CRow>
            </CCol>
          </CRow>
        </CCol>
        <CCol class="Learning">
          <CRow>
            <CCol class="col-sm-6">
              <h1>Learning Material :</h1>
            </CCol>
            <CCol class="col-sm-6 pl-0">
              <p v-if="dataCourse.data.data.controls.materials">
                <img class="check" src="@/assets/images/wait/Check.svg" />
                {{
                  $helpers.translate(
                    dataCourse.data.data.controls.materials[0].material
                      .material,
                    lang
                  )
                }},{{
                  $helpers.translate(
                    dataCourse.data.data.controls.materials[1].material
                      .material,
                    lang
                  )
                }}
              </p>
              <p v-else>-</p>
            </CCol>
          </CRow>
        </CCol>
        <CCol class="CourseLevel">
          <CRow>
            <CCol class="col-sm-6">
              <h1>Course Level :</h1>
            </CCol>
            <CCol class="col-sm-6 pl-0">
              <p v-if="checkLevel(dataCourse.data.data.controls)">
                <img class="check" src="@/assets/images/wait/Check.svg" />
                {{
                  $helpers.translate(
                    dataCourse.data.data.controls.levels.level.level,
                    lang
                  )
                }}
              </p>
              <p v-else>-</p>
            </CCol>
          </CRow>
        </CCol>
        <CCol class="Description">
          <h1>Course Objective :</h1>
        </CCol>
        <CCol class="Description">
          <!-- <p v-if="this.dataCourse.data.data.controls.objective">
            {{
              $helpers.translate(this.dataCourse.data.data.controls.objective, lang)
            }}
          </p>
          <p v-else>-</p> -->
          <div class="pl-1" v-for="(item, index) in courseObject" :key="index">
            <p>{{ item }}</p>
          </div>
        </CCol>
        <CCol class="Description">
          <h1>Course Description :</h1>
        </CCol>
        <CCol class="Description">
          <p v-if="this.dataCourse.data.data.controls.description">
            {{
              $helpers.translate(
                this.dataCourse.data.data.controls.description,
                lang
              )
            }}
          </p>
          <p v-else>-</p>
        </CCol>
        <CCol class="Credit">
          <CRow>
            <CCol xl="6" lg="6">
              <h1>MDL Digital Credit :</h1>
            </CCol>
            <CCol xl="6" lg="6">
              <p
                v-if="
                  dataCourse.data.data.controls.credits &&
                  dataCourse.data.data.controls.credits.length > 0
                "
              >
                {{ dataCourse.data.data.controls.credits }}
              </p>
              <p v-else>-</p>
            </CCol>
          </CRow>
        </CCol>
        <CCol class="Cetificate">
          <CRow>
            <CCol class="col-sm-6">
              <h1>Certificate :</h1>
            </CCol>
            <CCol class="col-sm-6">
              <p>
                <img
                  class="check"
                  src="@/assets/images/wait/Check.svg"
                  style="margin-left: -15px"
                />
                <span
                  v-if="
                    dataCourse.data.data.controls.certificates.length > 0 &&
                    dataCourse.data.data.controls.certificates[0] != undefined
                  "
                  >{{
                    dataCourse.data.data.controls.certificates[0].certificate
                      .certificateName[0].certificate_name
                  }}</span
                >
              </p>
            </CCol>
          </CRow>
        </CCol>
        <CCol class="Badge">
          <CRow>
            <CCol class="col-sm-6">
              <h1>Badge :</h1>
            </CCol>
            <CCol class="col-sm-6"></CCol>
          </CRow>
        </CCol>
      </CCol>
      <!-- Detail right -->
      <CCol class="CSDetailright mb-5 pl-0 pr-5 col-sm-5 col-12 mr-0">
        <h1>Comments & Rating</h1>
        <br />
        <CContainer class="box-comment">
          <div class="starrating" v-if="this.$store.getters['auth/userStatus']">
            <div>
              <star-rating
                :star-size="25"
                v-model="rating"
                :show-rating="false"
                class="star mb-1"
                style="margin-left: 1em; border-color: transparent"
              ></star-rating>
            </div>
            <img
              src="@/assets/images/wait/Dotwhite.png"
              width="100% margin-left:-10em;"
            />
            <textarea
              class="box-textarea"
              rows="3"
              v-model.trim="textComment"
            ></textarea>
            <br />
          </div>
          <br />
          <CButton
            block
            v-bind:style="styleObjectpost"
            class="btn-post"
            style="float: right"
            v-if="this.$store.getters['auth/userStatus']"
            @click="postComment()"
            >POST</CButton
          >
          <br />
        </CContainer>
        <CCol class="comment-shown">
          <template v-if="dataComment.length > 0">
            <CContainer
              v-for="(item, index) in dataComment.slice().reverse()"
              :key="index"
              class="ccard pl-0 pr-5"
            >
              <CRow class="w-100 m-0">
                <CCol v-if="item.create_by.user" class="Comment">
                  <img
                    v-if="
                      item.create_by.user.userinfo.userinfo.image_profile !=
                      null
                    "
                    class="photomini mt-2 pd-0"
                    :src="item.create_by.user.userinfo.userinfo.image_profile"
                  />
                  <i v-else class="fa fa-user"></i>

                  <CCol class="text-comment">
                    <CRow class="w-100 m-0">
                      <CCol col="12">
                        <star-rating
                          :star-size="20"
                          :show-rating="false"
                          :rating="item.rating"
                        ></star-rating>
                        <CCol
                          col="6"
                          class="text-mute text-left pl-0"
                          style="font-size: 16px"
                          v-if="item.create_by.user.username"
                          >{{ item.create_by.user.username }}
                        </CCol>
                        <CCol v-if="item.create_by.user" class="w-100 m-0 pl-0">
                          <CCol
                            class="text-mute text-left pl-0"
                            style="font-size: 10px"
                            v-if="item.create_by.date != undefined"
                            >{{ onDateFormat(item.create_by.date) }}</CCol
                          >
                          <CCol
                            col="6"
                            class="text-mute font-xs text-right"
                            v-else-if="
                              item.create_by.user.userinfo.userinfo.firstname
                                .length > 0 &&
                              item.create_by.user.userinfo.userinfo.lastname
                                .length > 0
                            "
                            >{{
                              item.create_by.user.userinfo.userinfo.firstname[0]
                                .val
                            }}
                            {{
                              item.create_by.user.userinfo.userinfo.lastname[0]
                                .val
                            }}</CCol
                          >
                        </CCol>
                        <p class="message mt-2 col-12 pl-0">{{ item.text }}</p>
                      </CCol>
                    </CRow>
                  </CCol>
                </CCol>
              </CRow>
            </CContainer>
          </template>
        </CCol>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import StarRating from 'vue-star-rating';
import {mdbContainer, mdbRow, mdbCol} from 'mdbvue';

export default {
  name: 'overview',
  data() {
    return {
      lang: 'en',
      styleObject: {
        color: 'black',
        background: '#FFBB00',
      },
      styleObjectpost: {
        color: 'white',
        background: '#0080FF',
      },
      Detail: 'Test detail',
      Detaillong: 'Test detaillong',
      Course: [],
      dataCourse: [],
      background: '',
      videoOverview: '',
      courseData: {},
      overviewName: '',
      badges: '',
      descriptionOverview: '',
      subTitle: '',
      title: '',
      courseObjective: '',
      courseDescription: '',
      dataComment: [],
      courseID: '',
      overviewCourse: '',
      textComment: '',
      create_by: [],
      rating: null,
      enrolled: false,
      loaded: false,
      loading: true,
      loadComment: false,
      getStartButton: '',
      enroll: [],
      tmpUserEnroll: [],
      modalEnroll: false,
      startpage: '',
      courseObject: [],
      courseSection: null,
      v3CourseId: null,
    };
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    StarRating,
  },

  computed: {
    ...mapGetters({
      mfuREGEnrollSingle: 'courses/mfuREGEnrollSingle',
      mfuREGEnrollSingleFail: 'courses/mfuREGEnrollSingleFail',

      getdataCourse: 'getdataCourse',
      getCoursePage: 'courses/getCoursePage',
      getDataComment: 'getDataComment',
      getCommentPosted: 'getCommentPosted',
      userCourseGetter: 'userCourseGetter',
      isAuth: 'auth/userStatus',

      // v3
      v3CourseEnroll: 'v3/v3CourseEnroll',
      v3IsEnroll: 'v3/v3IsEnroll',
      v3NotifyEnroll: 'v3/v3NotifyEnroll',
    }),
  },
  watch: {
    v3NotifyEnroll: function (val) {
      console.log('zzzzzzzz')
      if (val) {
        this.enrolled = false;
        this.getStartButton = 'ENROLL';
        this.loading = false;
        this.modalEnroll = true;
      }
      this.$store.commit('v3/v3notifyEnrollOff');
    },
    v3IsEnroll: function (val) {
      console.log('v3IsEnroll v3IsEnroll v3IsEnroll', val);

      if (val.isEnroll) {
        // ไปยังหน้าบทเรียนของแต่ละวิชานั้นๆ
        const v3ContentId = this.dataCourse.data.data.v3Contents[0].content;
        this.$store.commit('v3/setFetchDataBy', 'id'); // call mutation from vuex storage
        this.$router.push(`/display/${v3ContentId}`);
      } else {
        this.enrolled = false;
        this.getStartButton = 'ENROLL';
        alert(
          'You are not enroll this course, please enroll before begin lesson'
        );
      }
    },
    v3CourseEnroll: function (val) {
      // // ฟังชั่นสำหรับกดสมัครผ่านหน้า overview

      console.log('v3CourseEnroll v3CourseEnroll v3CourseEnroll', val);

      if (val) {
        console.log('Already Enrolled');
        this.enrolled = true;
        this.getStartButton = 'BEGIN';
      } else {
        console.log('Not enroll this course');
        this.enrolled = false;
        this.getStartButton = 'ENROLL';
      }

      // // เมื่อสมัครเสร็จเเล้ว
      // console.log('=====================');
      // console.log('Enroll Success', val);
      // console.log('=====================');

      this.loading = false;
    },
    mfuREGEnrollSingle: function (val) {
      this.$router.push({
        name: 'homepage',
      });
    },
    mfuREGEnrollSingleFail: function (val) {
      console.log('xxxxxx', val);
      this.modalEnroll = true;
    },

    getCoursePage: function (val) {
      console.log('rrrrrrrrr');
      this.startpage = val.data;
      this.loading = false;
    },
    getdataCourse: function (val) {
      console.log('getdataCourse', val);

      this.dataCourse = val;
      this.courseSection = val.data.section;
      this.$store.commit('necessary/setUserCourseSection', val.data.section);
      this.getBackgroundImage();
      //this.addViewer(); // // V3 Fix Viewer
      this.spliceText();
      this.loaded = true;
      // if (this.$store.getters['auth/userStatus']) {
      //   this.$store.dispatch('courses/fetchCoursePage', val.data.data._id);
      // }
    },
    getCommentPosted: function (val) {
      if (val) {
        this.$store.dispatch('getComment', this.courseID);
      }
    },
    getDataComment: function (val) {
      /// Get 5 comment
      this.dataComment = val;
    },
    isAuth: function () {
      if (this.$store.getters['auth/userStatus']) {
        this.$store.dispatch('fetchUserDataByToken');
      }
    },
    userCourseGetter: function (val) {
      if (val) {
        // this.enroll = this.$store.getters['userCourseGetter'].enrolls; //v3
        console.log(
          'userCourseGetter',
          this.$store.getters['userCourseGetter']
        );
        const userCourse = this.$store.getters['userCourseGetter'];

        for (let i = 0; i < userCourse.length; i++) {
          const course = userCourse[i];
          if (!course.courseinfo) continue;
          if (this.courseID == course.courseinfo._id) {
            console.log('Match course enroll', course);

            if (course.enroll == true) {
              this.enroll = course.enroll;
            }
          }
        } // loop
        this.onCheckEnroll();
      }
    },
  },
  created() {
    this.loaded = false;
    this.courseID = this.$router.history.current.params.courseObjectId;
    this.courseCode = this.$store.state.necessary.courseCode;
    this.$store.commit('v3/v3SetCourseEnroll'); // สำหรับเปิดปุ่มกด enroll ของ v3

    if (this.$store.getters['auth/userStatus']) {
      this.checkIsLogin = this.$store.getters['auth/userStatus'] ? true : false;
      this.$store.dispatch('fetchUserDataByToken');
    }
  },
  mounted() {
    this.onLoadpage();
  },
  beforeDestroy() {
    this.$store.commit('v3/v3notifyEnrollOff');
  },
  methods: {
    clickREGLINK() {
      this.modalEnroll = false;
      // Replace 'https://www.example.com' with the URL of the website you want to open in the new tab
      const url = 'https://reg.mfu.ac.th/th/contact-us';
      // Open the URL in a new tab
      window.open(url, '_blank');
    },
    addViewer() {
      let body = {
        type: 6,
        courseId: this.dataCourse.data.data._id,
        data: this.$store.getters['auth/userInformation']._id,
      };
      this.$store.dispatch('addViewer', body);
    },
    checkLevel(params) {
      if (typeof params.levels == 'undefined') {
        return false;
      }
      return true;
    },
    onCheckEnroll() {
      console.log('ACTIVE onCheckEnroll');

      if (this.$store.getters['auth/userStatus'] === false) {
        // v3 authentication check
        this.enrolled = false;
      } else {
        if (this.enroll == true) {
          // checking enroll status
          console.log('Hi this is ALREADY ENROLLED');
          this.getStartButton = 'BEGIN';
          this.enrolled = true;
          this.loading = false;
        } else {
          console.log('Hi this is NOT ENROLL, Please ENROLL');

          this.getStartButton = 'ENROLL';
          this.enrolled = false;
          this.loading = false;
        }

        // if (this.enroll !== undefined || this.enroll.length != 0) {
        //   this.getStartButton = 'ENROLL';
        //   var match = this.enroll.filter((el) => {
        //     if (el._id == this.courseID) {
        //       return el;
        //     } else {
        //       return null;
        //     }
        //   });
        //   this.tmpUserEnroll = match[0];
        //   if (match !== null && match.length !== 0) {
        //     this.enrolled = true;
        //     this.getStartButton = 'BEGIN';
        //   } else {
        //     this.getStartButton = 'ENROLL';
        //     this.enrolled = false;
        //     this.loading = false;
        //     this.$store.commit('v3/v3SetCourseEnroll'); // สำหรับเปิดปุ่มกด enroll ของ v3
        //   }
        // } else {
        //   this.loading = false;
        //   this.getStartButton = 'ENROLL';
        //   this.$store.commit('v3/v3SetCourseEnroll'); // สำหรับเปิดปุ่มกด enroll ของ v3
        // }
      } // else main
    },
    onDateFormat(date) {
      return new Date(date).toISOString().replace(/T/, ' ').replace(/\..+/, '');
    },
    Getstart() {
      
      if (this.enrolled == true && this.getStartButton == 'BEGIN') {
        // this.$store.commit('necessary/setLearningCourse', this.tmpUserEnroll); // เก็บไอดีของวิชาไว้
        this.$store.commit('necessary/setLearningCourse', this.courseID);
        
        // alert('You enrolled in section : '+this.courseSection)
        //check dataCourse v3Content
        if (this.dataCourse.data.data.v3Contents && this.courseCode != '1901309') {
          
          if (this.dataCourse.data.data.v3Contents.length > 0) {
            console.log('this.enrolled', this.enroll, this.enrolled);

            // ยิงไปเช็คข้อมูลจากหลังบ้านก่อนว่าลงทะเบียนเเล้วหรือไม่
            this.$store.dispatch('v3/v3IsEnroll', {
              courseId: this.dataCourse.data.data._id,
            });
          }
        } else {
          console.log('yyyyyyyy')
          this.startpage = 'CPRMENU'
          var routeCode = this.startpage.split('-');
          if (routeCode.length > 1) {
            console.log('vvvvvv')
            console.log(routeCode[0], {id: routeCode[1]})
            this.$router.push({
              name: routeCode[0],
              params: {id: routeCode[1]},
            });
          } else {
            console.log('bbbbbb')
            console.log({name: this.startpage})
            this.$router.push({
              name: 'v4CPR-MENU',
            });
          }
        }
      } else {
        console.log('click enroll', this.courseCode);
        const payload = {
          courseId: this.courseID,
          type: 'STUDENT',
          contentId: this.dataCourse.data.data.v3Contents[0].content,
          courseCode: this.courseCode,
          section: 'testing',
        };
        console.log('----------------------');
        
        this.$store.dispatch('v3/v3CourseEnroll', payload);
        this.loading = true;
        // this.modalEnroll = true;
        // this.$store.dispatch('courses/mfuREGEnrollSingle', this.courseID); //สำหรับเด้ง popup แจ้งเตือนนศ หากไม่มีวิชาในตาราง
      }
    },
    onLoadpage() {
      console.log(' this.courseID', this.courseID);
      this.$store.dispatch('fetchCoursesOverview', this.courseID);
      this.$store.dispatch('getComment', this.courseID);
    },
    languageEnglish(object) {
      for (let index = 0; index < object.length; index++) {
        let element = object[index];
        if (element.key == 'en') {
          return element.val;
        }
      }
    },
    getBackgroundImage() {
      const bg = this.dataCourse.data.data.style.background[0];
      if (bg != null && bg != undefined) {
        this.background = 'background-image: url(' + bg.url + ')';
      } else {
        this.background =
          "background-image: url('https://i.pinimg.com/736x/69/e1/ee/69e1ee0746b972a9e9fedbf56c4ea2b2.jpg')";
      }
    },
    getVideoUrl() {
      return 'src : ' + this.videoOverview + '';
    },
    postComment() {
      let _id = this.$store.getters['profile/getUserId'];
      let comment = {
        text: this.textComment,
        create_by: {
          user: _id,
          update: [],
        },
        course: this.courseID,
        rating: this.rating,
        items: {
          url: '',
          type: 0,
        },
      };

      if (this.textComment == '') {
        alert('Please input Comment');
      } else {
        this.$store.dispatch('postComment', comment);
        this.rating = 0;
        this.textComment = '';
      }
    },
    spliceText() {
      let data = this.$helpers.translate(
        this.dataCourse.data.data.controls.objective,
        this.lang
      );
      this.courseObject = data.split('//');
    },
  },
};
</script>
<style>
.embed-responsive-item {
  height: auto !important;
}

textarea {
  resize: none;
}

.modalEnroll {
  width: 480px;
  height: auto;
  background-color: white;
  border-radius: 30px;
  opacity: 1;
  padding-top: 0.5em;
  text-align: center;
}

.modalEnroll h2 {
  text-align: center;
  margin-top: 15px;
  font-family: 'Roboto', Medium;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.closeButton {
  align-content: flex-end;
  float: right;
  width: 26px;
  height: 26px;
  padding-top: -100px;
  cursor: pointer;
  margin-bottom: 0.1em;
}

.modalEnroll p {
  text-align: center;
  margin-top: 15px;
  font-family: 'Roboto', Medium;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  padding-left: 77px;
  padding-right: 77px;
}

.btnModal-enroll {
  justify-content: center;
  background: #0080ff;
  width: 173px;
  height: 35px;
  color: white;
  font-weight: 600;
}
</style>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.closeBtnContainer {
  padding-right: 1rem;
}

.photo {
  /* filter: brightness(80%); */
  background: linear-gradient(
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 0.3)
  );
  min-height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  padding-right: 0;
  padding-left: 0;
  overflow: hidden;
}

.card-carousel {
  height: auto;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 30vh;
  margin-bottom: 25vh;
}

.check {
  width: 18px;
  height: 18px;
  margin-right: 15px;
}

.embed-responsive {
  height: 50vh;
  margin-right: 15px;
}

.content h1 {
  color: white;
  font-weight: 500;
  font-family: 'Roboto', Medium;
  font-size: 4em;
  opacity: 1;
}

.p-content {
  color: whitesmoke;
  font-weight: 300;
  font-family: 'Roboto', sans-serif;
  font-size: 25px;
  letter-spacing: 0;
  opacity: 1;
}

.btn-overview {
  margin-bottom: 5em;
  font-weight: bold;
  font-size: 16px;
  background-color: #ffbb00;
}

.btn-disable {
  margin-bottom: 5em;
  font-weight: bold;
  font-size: 16px;
  background-color: #bebebe;
}

.btn-overview:hover {
  color: white !important;
  background-color: #ffbb00;
}

.btn-post {
  margin-bottom: 3em;
  font-weight: bold;
  font-size: 16px;
}

.CSDetailleft {
  height: auto;
  font-family: 'Roboto', sans-serif;
  background-color: white;
  margin-top: 2em;
  margin-left: 4em;
  margin-right: 1em;
  color: #000000;
}

.CSDetailleft h1 {
  font-size: 40px;
  font-weight: 500;
  font-weight: bold;
  color: #000000;
}

.CSDetailright {
  height: auto;
  font-family: 'Roboto', sans-serif;
  background-color: white;
  float: right;
  margin-top: 2em;
  margin-right: 3em;
  color: #000000;
}

.CSDetailright h1 {
  font-size: 40px;
  font-weight: 500;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
  color: #000000;
}

.photomini {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-repeat: no-repeat;
  object-fit: cover;
  color: #000000;
}

.Comment {
  width: 5rem;
  margin-left: -1em;
  font-family: 'Roboto', sans-serif;
  color: #000000;
}

.text-comment {
  margin-left: 4em;
  font-family: 'Roboto', sans-serif;
  margin-top: -4em;
  color: #000000;
}

.comment-shown {
  height: 400px;
  overflow-y: auto;
}

.ccard {
  width: 100%;
  height: auto;
  display: flex;
  margin-top: 1em;
}

.starrating {
  width: 100%;
  height: 200px;
  border-radius: 25px;
  background-color: #cccccc;
  border-color: transparent;
  border: 0;
}

.star {
  margin-top: 1em;
  border-color: transparent;
  float: left;
  border: 0;
}

/* .vue-star-rating {
      margin-top: 0.5em;
      margin-left: 0.5em;
      float: left;
    } */

.imposrt-pic {
  float: right;
  width: 30px;
  height: auto;
  margin-top: 1em;
  margin-right: 1.5em;
}

.box-textarea {
  width: 97%;
  background-color: #cccccc;
  margin-left: 0.5em;
  margin-right: 0.5em;
  border-radius: 20px;
  border-color: transparent;
}

.User {
  font-family: 'Roboto', sans-serif;
  font-size: 22px;
  font-weight: 500px;
  color: black;
  margin-top: -2em;
}

.message {
  font-family: 'Roboto';
  font-size: 1.2rem;
  font-weight: 200px;
  color: black;
}

.CourseInfo {
  float: left;
  margin-top: 2em;
  margin-left: -1em;
}

.CourseInfo h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
}

.CourseInfo p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
}

.CourseType {
  float: left;
  margin-left: -1em;
}

.CourseType h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.CourseType p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  color: #000000;
}

.Catagory {
  float: left;
  margin-top: 0.5em;
  margin-left: -1em;
}

.closeButtonItem {
  background-color: white;
  border-radius: 50%;
}

.Catagory h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.Catagory p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  color: #000000;
}

.Instructor {
  float: left;
  margin-top: 0.5em;
  margin-left: -1em;
}

.Instructor h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.Instructor p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  color: #000000;
}

.box-comment {
  padding: 0;
  width: 100%;
}

.Learning {
  float: left;
  margin-top: 0.5em;
  margin-left: -1em;
}

.Learning h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.Learning p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  color: #000000;
}

.StudyTime {
  float: left;
  margin-top: 0.5em;
  margin-left: -1em;
}

.StudyTime p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  color: #000000;
}

.StudyTime h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.CourseLevel {
  float: left;
  margin-top: 0.5em;
  margin-left: -1em;
}

.CourseLevel h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.CourseLevel p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  color: #000000;
}

.CourseObjectivel {
  float: left;
  margin-top: 0.5em;
  margin-left: -1em;
}

.CourseObjectivel h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.CourseObjectivel p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  color: #000000;
}

.Description {
  float: left;
  margin-top: 0.5em;
  margin-left: -1em;
}

.Description h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.Description p {
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  text-indent: 1.5em;
  color: #000000;
}

.Credit {
  float: left;
  margin-top: 0.5em;
  margin-left: -1em;
}

.Credit h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.Credit p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  color: #000000;
}

.Cetificate {
  float: left;
  margin-top: 0.5em;
  margin-left: -1em;
}

.Cetificate h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.Cetificate p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  color: #000000;
}

.Badge {
  float: left;
  margin-top: 0.5em;
  margin-left: -1em;
}

.Badge h1 {
  float: left;
  font-size: 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #000000;
}

.Badge p {
  float: left;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  color: #000000;
}

.areafix {
  resize: none;
}

[type='file'] {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;
}

.btn {
  width: 150px;
  height: 50px;
  border-radius: 25px;
}

@media only screen and (min-width: 300px) and (max-width: 360px) {
  .embed-responsive {
    position: absolute;
    width: 350px;
    height: 200px;
    top: -30%;
    right: -25px;
    margin-top: 5px;
  }

  .text-justify {
    text-align: left !important;
  }

  .content {
    padding-left: 0;
    padding-right: 0;
    margin-top: 70px;
  }

  .content h1 {
    color: white;
    font-weight: bold;
    font-family: 'Roboto', Medium;
    font-size: 30px;
    margin-top: 0;
  }

  .p-content {
    color: white;
    font-weight: 300;
    font-family: 'Roboto', sans-serif;
    font-size: 18px;
    letter-spacing: 0;
  }

  .btn-overview {
    margin-bottom: 0;
    margin-top: -0.5em;
  }

  .CSDetailleft {
    margin-left: 0;
    margin-right: 0;
  }

  .photo {
    padding-right: 0;
    padding-left: 0;
  }

  .hidden {
    margin-left: 1.5em;
    margin-top: -180px;
  }

  .starrating {
    margin-left: 1em;
  }

  .Comment {
    margin-left: 0;
    margin-right: 0;
    padding-left: 15px;
    padding-right: 0;
    color: #000000;
  }

  .text-comment {
    margin-left: 3em;
    margin-top: -4em;
    padding-right: 0;
    color: #000000;
  }

  .CSDetailright h1 {
    margin-left: 0.25em;
    color: #000000;
  }

  .CSDetailleft h1 {
    font-size: 25px;
  }

  .CourseInfo h1 {
    font-size: 20px;
  }

  .CourseType h1 {
    font-size: 20px;
  }

  .StudyTime h1 {
    font-size: 20px;
  }

  .Catagory h1 {
    font-size: 20px;
  }

  .Learning h1 {
    font-size: 20px;
  }

  .CourseLevel h1 {
    font-size: 20px;
  }

  .Description h1 {
    font-size: 20px;
  }

  .Credit h1 {
    font-size: 20px;
  }

  .Cetificate h1 {
    font-size: 20px;
  }

  .Badge h1 {
    font-size: 20px;
  }

  .CSDetailright h1 {
    font-size: 20px;
  }
}

@media only screen and (min-width: 375px) and (max-width: 450px) {
  .photo {
    height: auto;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .CSDetailleft h1 {
    font-size: 25px;
  }

  .CourseInfo h1 {
    font-size: 20px;
  }

  .CourseType h1 {
    font-size: 20px;
  }

  .StudyTime h1 {
    font-size: 20px;
  }

  .Catagory h1 {
    font-size: 20px;
  }

  .Learning h1 {
    font-size: 20px;
  }

  .CourseLevel h1 {
    font-size: 20px;
  }

  .Description h1 {
    font-size: 20px;
  }

  .Credit h1 {
    font-size: 20px;
  }

  .Cetificate h1 {
    font-size: 20px;
  }

  .Badge h1 {
    font-size: 20px;
  }

  .CSDetailright h1 {
    font-size: 20px;
  }

  .embed-responsive {
    position: absolute;
    width: 450px;
    height: 200px;
    top: -40%;
    right: -32px;
    margin-top: 5px;
  }

  .text-justify {
    text-align: left !important;
  }

  .content {
    padding-left: 0;
    padding-right: 0;
    margin-top: 60px;
  }

  .content h1 {
    color: white;
    font-weight: bold;
    font-family: 'Roboto', Medium;
    font-size: 25px;
    margin-top: 0;
  }

  .p-content {
    color: white;
    font-weight: 300;
    font-family: 'Roboto', sans-serif;
    font-size: 18px;
    letter-spacing: 0;
  }

  .btn-overview {
    margin-bottom: 0;
    margin-top: -0.5em;
  }

  .CSDetailleft {
    margin-left: 0;
    margin-right: 0;
  }

  .photo {
    padding-right: 0;
    padding-left: 0;
  }

  .hidden {
    margin-left: 1.5em;
    margin-top: -180px;
  }

  .starrating {
    margin-left: 1em;
  }

  .Comment {
    margin-left: 0;
    margin-right: 0;
    padding-left: 15px;
    padding-right: 0;
    color: #000000;
  }

  .text-comment {
    margin-left: 3em;
    margin-top: -4em;
    padding-right: 0;
    color: #000000;
  }

  .CSDetailright h1 {
    margin-left: 0.25em;
    color: #000000;
  }
}
</style>
